// Customers GraphQL mutations

import { gql } from "@apollo/client"

export const CREATE_CUSTOMER = gql`
  mutation CreateCustomer($input: CreateCustomerInput!) {
    createCustomer(input: $input) {
      id
      customerID
      customerName
      legalName
      status
      email
      phone1
      country
      city
      postalCode
      addressLine1
      currencyID
      terms
      customerClass
      taxZone
      locationName
    }
  }
`

export const UPDATE_CUSTOMER = gql`
  mutation UpdateCustomer($input: UpdateCustomerInput!) {
    updateCustomer(input: $input) {
      id
      customerID
      customerName
      legalName
      status
      email
      phone1
      country
      city
      postalCode
      addressLine1
      currencyID
      terms
      customerClass
      taxZone
      locationName
    }
  }
`
